
    import Component from 'vue-class-component';
    import {
        PositionApiModel, 
        PositionsRequirementViewModel,
        RequirementsClient
    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import RequirementSummary from "@/features/applications/components/RequirementSummary";

    @Component({
        components: {}
    })
    export default class PositionsRequirementSummary extends RequirementSummary {

        @Prop({required: true})
        requirement!: PositionsRequirementViewModel;

        chosen: PositionApiModel[] = [];

        async created() {
            if (this.requirementValue) {
                this.chosen = await new RequirementsClient().chosenPositions(this.application.id, this.requirement.id);
            }
        }
    }
